import React from 'react';
import { Flex, Text, IconButton, useColorModeValue } from '@chakra-ui/react';
import { LuChevronDown, LuChevronRight } from 'react-icons/lu';
import { formatHeaderMeta } from './capacity/capacity.util';

export default function ScheduleGroupHeader({ label, count, isOpen, onToggle }) {
  const bg = 'transparent';
  const border = 'transparent';
  const chipLabel = formatHeaderMeta(count || 0);

  return (
    <Flex
      align="center"
      justify="space-between"
      px={0}
      py={1}
      mt={0}
      mb={0}
      borderWidth="0px"
      borderColor={border}
      bg={bg}
      cursor="pointer"
      onClick={onToggle}
      role="button"
      aria-expanded={isOpen}
    >
      <Text fontSize="sm" fontWeight="semibold">
        {label}
        <Text as="span" fontSize="sm" fontWeight="normal" color="gray.400" ml={2}>
          • {formatHeaderMeta(count || 0)}
        </Text>
      </Text>
      <Flex align="center" gap="2">
        <IconButton
          aria-label={isOpen ? 'Collapse' : 'Expand'}
          icon={isOpen ? <LuChevronDown /> : <LuChevronRight />}
          size="sm"
          variant="ghost"
          onClick={(e) => { e.stopPropagation(); onToggle(); }}
        />
      </Flex>
    </Flex>
  );
}
